import React from 'react'
import { Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  color: #505c7c;
  .modal-content {
    background: ${(props) => (props.isWinner ? '#d3ffbf' : 'rgba(255, 170, 170, 0.6)')};
    backdrop-filter: blur(39.400001525878906px);
    padding: min(24px, 3vw);
    border: none;
    border-radius: 20px;
  }
  .modal-header {
    border: none;
    justify-content: flex-end;
  }
  .modal-body {
    padding: min(24px, 3vw);


    h4 {
      font-size: 2rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.875rem;
      margin-bottom: 24px;
    }
    p {
      font-size: 1rem;
      font-style: normal;
      font-weight: 700;
      margin-bottom: 24px;
      line-height: normal;
    }

    .content {
      width: 100%;
      background: #fff;
      border-radius: 12px;
      text-align: center;
      padding: 60px;
    }

    .theme-btn {
      padding: 10px 20px;
    }
  }
`

export default function LuckyDrawModal({ showModal, hideModal }) {
  const currentUser = useSelector((state) => state.auth.currentUser)

  return (
    <StyledModal show={showModal} onHide={hideModal} size="lg" aria-labelledby="info-modal" centered>
      <Modal.Body isWinner={currentUser.luckyDrawStarted && currentUser.isWinner}>
        <div className="content">
          {!currentUser.luckyDrawStarted ? (
            <h4>Coming Soon</h4>
          ) : (
            <>
              <h4>{currentUser.isWinner ? 'Congratulations!' : 'Thank You for Participating'}</h4>
              <p>
                {currentUser.isWinner
                  ? 'You&apos;ve been selected as one of our lucky draw winners!'
                  : 'Unfortunately, you were not selected in this lucky draw, but we truly appreciate your participation!'}
              </p>
            </>
          )}
          <button className="theme-btn" onClick={hideModal}>
            Back to Lobby
          </button>
        </div>
      </Modal.Body>
    </StyledModal>
  )
}
